import { Map } from 'immutable';
import moment from 'moment';
import * as BetStatus from '../../constants/BetStatus';
import * as MakeBetActions from '../../actions/makeBet';
import * as BetCreateErrorStatus from '../../constants/BetCreateErrorStatus';
import { GET_BET_STATUS, GET_MULTI_BET_STATUS } from '../../sagas/actions';
import { OPEN_BETSLIP_MODAL, CLOSE_BETSLIP_MODAL, CLEAR_BETSLIPS } from '../../actions/coupon/coupon';
import * as Actions from '../../actions/coupon/coupon';
import * as CancelBigStakeAction from "../../actions/BigStakeRequest";
var initialState = new Map({
    loading: false,
    status: BetStatus.INIT,
    delay: undefined,
    resolution: undefined,
    stakeTime: undefined,
    stakeId: undefined,
    betCreateError: undefined,
    bets: new Map(),
    bigStakeCancelError: undefined,
    freebetErrors: undefined,
    limit: undefined
});
export default function quickBetReducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case CLEAR_BETSLIPS:
            state = state.update('freebetErrors', function () { return undefined; });
            return state.update('bets', function () { return new Map(); });
        case Actions.ACCEPT_FACTOR_CHANGE:
            return state.update('betCreateError', function () { return undefined; });
        case MakeBetActions.MAKE_MULTI_SINGLE_BET:
        case MakeBetActions.MAKE_BET:
            state = state.update('betCreateError', function () { return undefined; });
            return state = state.set('loading', true);
        case MakeBetActions.SUCCESS_MAKE_BET:
            state = state.set('loading', false);
            return betCreated(state, action.data);
        case MakeBetActions.SUCCESS_MAKE_MULTI_SINGLE_BET:
            state = state.set('loading', false);
            var data = action.data;
            var failure = data.find(function (f) { return f.State !== BetStatus.CONFIRMED; });
            if (!failure) {
                return state.update('status', function () { return BetStatus.CONFIRMED; });
            }
            else {
                data.map(function (factor) {
                    state = multiSingleBetCreated(state, factor);
                });
                return state;
            }
        case Actions.CLEAR_CASHE_FREEBET:
            return state.update('freebetErrors', function () { return undefined; });
        case MakeBetActions.FAILURE_MAKE_MULTI_SINGLE_BET:
            state = state.set('loading', false);
            return state.update('status', function () { return BetStatus.REJECTED; });
        case MakeBetActions.FAILURE_MAKE_BET:
            state = state.set('loading', false);
            state = state.set('status', BetStatus.REJECTED);
            return state.set('betCreateError', BetCreateErrorStatus.INTERNAL_ERROR);
        case OPEN_BETSLIP_MODAL:
            return state.set('loading', false);
        case CLOSE_BETSLIP_MODAL:
            state = state.set('resolution', undefined);
            state = state.set('betCreateError', undefined);
            return state.set('status', BetStatus.INIT);
        case GET_BET_STATUS.SUCCESS:
            state = state.set('loading', false);
            return changeBetStatus(state, action.data);
        case GET_MULTI_BET_STATUS.SUCCESS:
            state = state.set('loading', false);
            return changeMultiBetStatus(state, action.data);
        case CancelBigStakeAction.SUCCESS_BIG_STAKE_REQUEST_CANCEL:
            var bigStakeRequestCancel = action.data;
            var error = bigStakeRequestCancel.Error;
            if (error !== undefined) {
                if (error === -1) {
                    state = state.update('bigStakeCancelError', function () { return 1; });
                }
                else if (error === -100) {
                    return state;
                }
            }
            return state.update('status', function () { return BetStatus.REJECTED; });
        default:
            return state;
    }
}
function betError(error) {
    switch (error) {
        case -3:
            return BetCreateErrorStatus.FACTORS_CHANGED;
        case -4:
            return BetCreateErrorStatus.INSUFFICIENT_FUNDS;
        case -7:
        case -15:
            return BetCreateErrorStatus.ACCOUNT_LOCKED;
        case -6:
            return BetCreateErrorStatus.MIN_STAKE_AMOUNT;
        case -1:
        case -2:
        case -13:
            return BetCreateErrorStatus.INCORRECT_STAKE;
        case -5:
        case -11:
            return BetCreateErrorStatus.INCORRECT_VIRTUAL_STAKE;
        case -12:
            return BetCreateErrorStatus.FREEBET_BIG_STAKE;
        case -9:
        case -10:
            return BetCreateErrorStatus.INCORRECT_FREEBET_STAKE;
        case -14:
            return BetCreateErrorStatus.EXISTING_ACTIVE_STAKE;
        case -16:
            return BetCreateErrorStatus.NO_BIG_STAKE_PERMISSION;
        case -18:
            localStorage.removeItem('couponAmountValue');
            return BetCreateErrorStatus.ALTERNATIVE_STAKE;
        case -19:
            return BetCreateErrorStatus.LIMIT_EXCEEDED;
        default:
            return BetCreateErrorStatus.INTERNAL_ERROR;
    }
}
function betCreated(coupon, createdBet) {
    if (createdBet.Error) {
        coupon = coupon.set('status', BetStatus.REJECTED);
        coupon = coupon.set('betCreateError', betError(createdBet.Error));
        coupon = coupon.set('alternativeStake', createdBet.AlternativeStake);
        coupon = coupon.set('limit', createdBet.Limit);
        return coupon;
    }
    else if (createdBet.FreebetErrors) {
        coupon = coupon.set('status', BetStatus.REJECTED);
        coupon = coupon.set('freebetErrors', createdBet.FreebetErrors);
        coupon = coupon.set('alternativeStake', createdBet.AlternativeStake);
        coupon = coupon.set('limit', createdBet.Limit);
        return coupon;
    }
    else {
        var status_1 = createdBet.State;
        switch (status_1) {
            case BetStatus.CONFIRMED:
                return coupon.update('status', function () { return status_1; });
            case BetStatus.IN_DELAY:
            case BetStatus.STAKE_REQUEST:
            case BetStatus.CONFIRM_AWAIT:
                var stakeTime = moment.tz(createdBet.StakeTime, 'Asia/Bishkek').clone().tz('UTC');
                coupon = coupon.set('status', status_1);
                coupon = coupon.set('stakeId', createdBet.BetId);
                coupon = coupon.set('delay', createdBet.Delay);
                coupon = coupon.set('stakeTime', stakeTime);
                return coupon;
            default:
                return coupon.update('status', function () { return BetStatus.INIT; });
        }
    }
}
function multiSingleBetCreated(coupon, createdBet) {
    if (createdBet.Error) {
        coupon = coupon.setIn(['bets', createdBet.BetNum, 'status'], BetStatus.REJECTED);
        coupon = coupon.setIn(['bets', createdBet.BetNum, 'betCreateError'], betError(createdBet.Error));
        if (createdBet.AlternativeStake) {
            coupon = coupon.setIn(['bets', createdBet.BetNum, 'alternativeStake'], createdBet.AlternativeStake);
        }
        if (createdBet.Error === -19 && createdBet.Limit && createdBet.Limit > 0) {
            coupon = coupon.setIn(['bets', createdBet.BetNum, 'limit'], createdBet.Limit);
            coupon = coupon.setIn(['bets', createdBet.BetNum, 'errorCode'], createdBet.Error);
        }
        return coupon;
    }
    else {
        var status = createdBet.State;
        switch (status) {
            case BetStatus.CONFIRMED:
                return coupon.setIn(['bets', createdBet.BetNum, 'status'], status);
            case BetStatus.IN_DELAY:
            case BetStatus.STAKE_REQUEST:
            case BetStatus.CONFIRM_AWAIT:
                var stakeTime = moment.tz(createdBet.StakeTime, 'Asia/Bishkek').clone().tz('UTC');
                coupon = coupon.setIn(['bets', createdBet.BetNum, 'status'], status);
                coupon = coupon.setIn(['bets', createdBet.BetNum, 'stakeId'], createdBet.BetId);
                coupon = coupon.setIn(['bets', createdBet.BetNum, 'delay'], createdBet.Delay);
                coupon = coupon.setIn(['bets', createdBet.BetNum, 'stakeTime'], stakeTime);
                return coupon;
            default:
                return coupon.setIn(['bets', createdBet.BetNum, 'status'], BetStatus.INIT);
        }
    }
}
function changeBetStatus(coupon, betStatus) {
    if (betStatus.error) {
        if (betStatus.error === -100) {
            return coupon;
        }
        changeBetToRejected(coupon);
    }
    var state = betStatus.State;
    var resolution = betStatus.Resolution;
    var stakeTime = moment.tz(betStatus.StakeTime, 'Asia/Bishkek').clone().tz('UTC');
    coupon = coupon.update('status', function () { return state; });
    coupon = coupon.update('resolution', function () { return resolution; });
    coupon = coupon.update('stakeTime', function () { return stakeTime; });
    return coupon;
}
function changeBetToRejected(coupon) {
    coupon = coupon.set('status', BetStatus.REJECTED);
    return coupon.set('betCreateError', BetCreateErrorStatus.INTERNAL_ERROR);
}
function changeMultiBetStatus(coupon, betStatus) {
    var bets = coupon.get('bets');
    var betId = betStatus.BetId;
    if (betStatus.error) {
        if (betStatus.error === -100) {
            return coupon;
        }
        changeMultiBetToRejected(coupon);
    }
    var state = betStatus.State;
    var resolution = betStatus.Resolution;
    var stakeTime = moment.tz(betStatus.StakeTime, 'Asia/Bishkek').clone().tz('UTC');
    bets.map(function (bet, key) {
        if (bet.get('stakeId') === betId) {
            coupon = coupon.setIn(['bets', key, 'status'], state);
            coupon = coupon.setIn(['bets', key, 'resolution'], resolution);
            coupon = coupon.setIn(['bets', key, 'stakeTime'], stakeTime);
        }
    });
    return coupon;
}
function changeMultiBetToRejected(coupon) {
    coupon = coupon.set('status', BetStatus.REJECTED);
    return coupon.set('betCreateError', BetCreateErrorStatus.INTERNAL_ERROR);
}



// WEBPACK FOOTER //
// ./src/reducers/coupon/couponStatusReducer.js